export const DEFAULT_GENERATED_FILE_NAME = 'meme.png';
export const ACCEPTED_MIME_TYPES = ['image/jpg', 'image/jpeg', 'image/png', 'image/apng', 'image/gif', 'image/webp', 'image/avif'];
